import React from 'react';
import { StepProps } from '../types';

const StepOptions: React.FC<StepProps> = ({ state, onUpdate, onNext, isActive }) => {
  const maxOptions = 6;
  const minOptions = 2;

  const handleOptionChange = (index: number, value: string) => {
    const newOptions = [...state.options];
    newOptions[index] = value;
    onUpdate({ options: newOptions });
  };

  const addOption = () => {
    if (state.options.length < maxOptions) {
      onUpdate({ options: [...state.options, ''] });
    }
  };

  const removeOption = (index: number) => {
    if (state.options.length > minOptions) {
      const newOptions = state.options.filter((_, i) => i !== index);
      onUpdate({ options: newOptions });
    }
  };

  const isValid = state.options.filter(option => option.trim().length > 0).length >= minOptions;

  return (
    <>
      <h2 className="step-title">What are your options?</h2>
      {state.options.map((option, index) => (
        <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: '12px' }}>
          <input
            type="text"
            value={option}
            onChange={(e) => handleOptionChange(index, e.target.value)}
            placeholder={`Option ${index + 1}`}
            style={{ flex: 1 }}
            disabled={!isActive}
          />
          {state.options.length > minOptions && isActive && (
            <button
              className="remove-option"
              onClick={() => removeOption(index)}
              title="Remove option"
            >
              ×
            </button>
          )}
        </div>
      ))}
      {state.options.length < maxOptions && isActive && (
        <button
          className="add-option-btn"
          onClick={addOption}
        >
          + Add option
        </button>
      )}
      {isActive && (
        <button
          className="btn"
          onClick={onNext}
          disabled={!isValid}
          style={{ marginTop: '20px' }}
        >
          Next
        </button>
      )}
    </>
  );
};

export default StepOptions;
